<template>
<svg class="play-button" viewBox="0 0 100 100">
  <polygon points="0,0 100,50 0,100" fill="currentColor" />
</svg>
</template>

<script>
import Vue from 'vue'

export default Vue.component('play-button', {})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';

.play-button {
  color: $color-white;
  width: 5.6rem;
  transform: translate(-50%, -50%);
  transition: transform 0.25s $ease;
  z-index: 2;
  pointer-events: none;
  filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.35));
}
</style>


// WEBPACK FOOTER //
// src/components/play-button.vue